module.exports = __webpack_public_path__ + "img/voucher_details_failed.6d4716a3.svg";